var _this = this;

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'fixedBottomContainer',
  props: {
    // 底部元素高度 站位放抖动
    height: {
      "default": 52
    },
    // 接收 HTMLElement、VueComponent两种类型
    el: {
      "default": null,
      required: true
    },
    // 用于插入iframe来监听容器大小变化
    containerClassName: {
      "default": 'app-main'
    }
  },
  data: function data() {
    return {
      isScrollX: false,
      isFixedScrollBar: false
    };
  },
  watch: {
    // 初始传入el可能为null
    el: function el() {
      this.init();
    }
  },
  mounted: function mounted() {
    this.slideBarMousedownFlag = false; // 是否为slideBar滚动条滚动

    this.actualEl = null; // 实际的表格dom, 当el为VueComponent时, actualEl = el.$el

    this.elTableBody = null; // 当el为VueComponent时有值, el-table下的el-table__body节点

    this.appMain = document.getElementsByClassName(this.containerClassName)[0];
    this.fixedScrollBar = this.$refs.fixedScrollBar;
    this.slideBar = this.$refs.slideBar;
    this.fixedBottom = this.$refs.fixedBottom;
    this.bodyClientHeight = document.documentElement.clientHeight - this.fixedBottom.clientHeight;
    this.bodyWrapperBindEvent = false; // bodyWrapper是否已经绑定了scroll事件 用于防止重复绑定

    this.createIframeHtml();
    window.addEventListener('scroll', this.scrollY);
    window.addEventListener('resize', this.resize);

    if (this.el) {
      this.init();
    }
  },
  methods: {
    init: function init() {
      if (this.el.$el) {
        this.actualEl = this.el.$el;
        this.elTableBody = this.el.$el.getElementsByClassName('el-table__body')[0];
      } else {
        this.actualEl = this.el;
      }

      this.resize();
    },
    createIframeHtml: function createIframeHtml() {
      this.iframeHtml = document.createElement('iframe');
      this.iframeHtml.style.cssText = "\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        border: 0;\n        margin: 0;\n        display: block;\n        z-index: -999;\n    ";
      this.appMain.appendChild(this.iframeHtml);
      var iframeHtml = this.iframeHtml.contentWindow || this.iframeHtml;
      iframeHtml.addEventListener('resize', this.resizeIframeHtml);
    },
    // 检查容器是否需要fixed
    checkContainerFixed: function checkContainerFixed() {
      this.isFixedScrollBar = this.actualEl.getBoundingClientRect().bottom > this.bodyClientHeight && this.actualEl.getBoundingClientRect().top < this.bodyClientHeight - 150;
    },
    scrollY: function scrollY() {
      this.checkContainerFixed();
    },
    scrollElTableBody: function scrollElTableBody(e) {
      if (!this.slideBarMousedownFlag) {
        this.fixedScrollBar.scrollLeft = e.target.scrollLeft;
      }
    },
    scrollSlideBar: function scrollSlideBar(e) {
      if (this.slideBarMousedownFlag) {
        this.el.bodyWrapper.scrollLeft = e.target.scrollLeft;
      }
    },
    mouseEvent: function mouseEvent(e) {
      this.slideBarMousedownFlag = e.type === 'mousedown';
    },
    // 只考虑el-table有横向滚动条的情况
    setScrollBar: function setScrollBar() {
      this.isScrollX = this.el.layout.scrollX;

      if (!this.el.layout.scrollX) {
        return;
      }

      this.fixedScrollBar.style.width = this.actualEl.clientWidth + 'px';
      this.slideBar.style.width = this.elTableBody.clientWidth + 'px';

      if (!this.bodyWrapperBindEvent) {
        this.el.bodyWrapper.addEventListener('scroll', this.scrollElTableBody);
        this.bodyWrapperBindEvent = true;
      }
    },
    resize: function resize() {
      this.fixedBottom.style.width = this.appMain.clientWidth + 'px';
      this.fixedBottom.style.left = this.appMain.offsetLeft + 'px';
      this.bodyClientHeight = document.documentElement.clientHeight - this.fixedBottom.clientHeight;

      if (this.el) {
        this.checkContainerFixed();

        if (this.el.$el) {
          this.setScrollBar();
        }
      }
    },
    resizeIframeHtml: function resizeIframeHtml() {
      this.checkContainerFixed();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.el && this.el.bodyWrapper && this.el.bodyWrapper.removeEventListener('scroll', this.scrollElTableBody);
    this.iframeHtml && this.iframeHtml.removeEventListener('resize', this.resizeIframeHtml);
    window.removeEventListener('resize', this.resize);
    window.removeEventListener('scroll', this.scrollY);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}
/* script */


var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "yx-fixed-bottom-container",
    style: "height: " + _vm.height + "px"
  }, [_c("div", {
    ref: "fixedBottom",
    staticClass: "yx-fixed-bottom",
    "class": {
      "yx-fixed": _vm.isFixedScrollBar,
      "yx-default-width": !_vm.isFixedScrollBar
    }
  }, [_c("div", {
    ref: "fixedScrollBar",
    staticClass: "yx-fixed-scroll-bar",
    "class": {
      "yx-hide": !_vm.isScrollX || !_vm.isFixedScrollBar
    },
    on: {
      mousedown: _vm.mouseEvent,
      mouseup: _vm.mouseEvent,
      scroll: _vm.scrollSlideBar
    }
  }, [_c("div", {
    ref: "slideBar",
    staticClass: "yx-slide-bar"
  })]), _vm._v(" "), _vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

__vue_component__.install = function (Vue) {
  _newArrowCheck(this, _this);

  Vue.component(__vue_component__.name, __vue_component__);
}.bind(this);

export default __vue_component__;
